module.exports = __webpack_public_path__ + "img/GAME_LIGHTBUG1.6ba7255f.jpg";